import React from "react";
import { ActivityLog } from "../../../common/types";
import { UserNameWithDate } from "../UserNameWithDate";
import "./activity-log-item.scss";

interface ActivityLogComponentProps {
  activityLog: ActivityLog;
}

export const ActivityLogItem: React.FC<ActivityLogComponentProps> = ({ activityLog }) => (
  <div className={`c-activity-log-item c-activity-log-item--${activityLog.logType}`} key={activityLog.id}>
    <div>
      <UserNameWithDate userName={activityLog.userName} date={activityLog.createdAt} />
    </div>
    <div>{typeof activityLog.text === "string" ? activityLog.text : JSON.stringify(activityLog.text)}</div>
  </div>
);
